import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NameWrapper = styled.span`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-weight: 600;
`;
